export default "__VITE_ASSET__BmBGsgM0__"